import {TimelineLite} from "gsap";
import {TheCrypt} from "../TheCrypt";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";
import {TheCryptHelper} from "../utils/TheCryptHelper";
import {TheCryptSymbol} from "../symbols/TheCryptSymbol";


export class TheCryptSymbolHighlighter extends PIXI.Container {

    constructor() {
        super();
        this.name = "TheCryptSymbolHighlighter";
    }

    public static playXWayPotentialWinHighlighter(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (TheCrypt.model.mysterySymbolPotentialWin.length === 0) {
            return tl;
        }

        const linesNr:number = TheCrypt.model.mysterySymbolPotentialWin.length,
        stepTime:number = 0.2;
        let duration: number =linesNr*stepTime+0.3,
        startTime:number = 0;
        TheCrypt.model.mysterySymbolPotentialWin.forEach((lines: number[][], i: number) => {
            lines.forEach((line: number[]) => {
                if (!TheCrypt.model.wildOnReel[line[0]]) {
                    const sym: TheCryptSymbol = TheCrypt.realArea.getSymbol([line[0], line[1]]);
                    tl.add(sym.playWinHighlighter(duration), startTime);
                }
            });
            startTime += stepTime;
            duration -= stepTime;
        });
        return tl;
    }
}